/**
 * After a release, a tab that is still running the previous build asks for
 * page files that no longer exist, so a click changes nothing until the user
 * refreshes. Detect that failure and reload the page once, automatically.
 */
const KEY = "statlign:chunk-reload-at";
const WINDOW_MS = 30_000;

export function isStaleChunkError(err: unknown): boolean {
  const msg = String((err as { message?: string })?.message ?? err ?? "");
  return /Failed to fetch dynamically imported module|Importing a module script failed|error loading dynamically imported module|ChunkLoadError|Loading chunk [\w-]+ failed|Unable to preload CSS/i.test(
    msg,
  );
}

/** Reload once per 30s window; returns true when a reload was started. */
export function reloadForStaleChunk(): boolean {
  if (typeof window === "undefined") return false;
  try {
    const last = Number(sessionStorage.getItem(KEY) || 0);
    if (Date.now() - last < WINDOW_MS) return false;
    sessionStorage.setItem(KEY, String(Date.now()));
  } catch {
    /* storage blocked: still reload once */
  }
  window.location.reload();
  return true;
}

let installed = false;
export function installStaleChunkRecovery() {
  if (installed || typeof window === "undefined") return;
  installed = true;
  window.addEventListener("vite:preloadError", (event) => {
    event.preventDefault();
    reloadForStaleChunk();
  });
  window.addEventListener("unhandledrejection", (e) => {
    if (isStaleChunkError(e.reason)) reloadForStaleChunk();
  });
}
